import { ModalRoot } from "@tiendeo/react-components/dist/objects/Modal/Modal";
import React, { FC } from "react";
import styled from "styled-components";
import HeaderContainer from "components/HeaderContainer";
import SideMenuContainer from "components/SideMenuContainer";
import { MAIN_BLOCK_MAX_WIDTH } from "../ui/shared/constants";
import Footer from "ui/components/Footer/Footer";
import ProfileHead from "./ProfileHead";

const StyledContainer = styled.div`
    background: ${(props) => props.theme.colors.neutral.white};

    margin-top: ${(props) => props.theme.spacing.xs};
    margin-bottom: ${(props) => props.theme.spacing.xxl};
    margin-right: ${(props) => props.theme.spacing.xs};
    margin-left: ${(props) => props.theme.spacing.xs};

    display: flex;
    justify-content: center;

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin-top: ${(props) => props.theme.spacing.xxl};
        margin-right: ${(props) => props.theme.spacing.md};
        margin-left: ${(props) => props.theme.spacing.md};
    }
`;

const StyledMain = styled.main<{ isFullMain: boolean }>`
    background-color: ${(props) => props.theme.colors.neutral.white};
    flex: 1;
    position: relative;

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        ${(props) => !props.isFullMain && `max-width: ${MAIN_BLOCK_MAX_WIDTH};`}
    }
`;

const StyledSideMenuWrapper = styled.aside`
    margin-top: ${(props) => props.theme.spacing.md};
    display: none;

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        display: block;
    }
`;

const StyledPageWrapper = styled.div`
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        justify-content: space-between;
    }
`;

interface IProps {
    showTiendeoLogo?: boolean;
    showSidebar?: boolean;
    isFullMain?: boolean;
}

const Layout: FC<IProps> = ({
    children,
    showTiendeoLogo = false,
    showSidebar = true,
    isFullMain = false,
}) => {
    return (
        <>
            <ProfileHead />
            <StyledPageWrapper>
                <HeaderContainer showTiendeoLogo={showTiendeoLogo} />
                <StyledContainer>
                    {showSidebar && (
                        <StyledSideMenuWrapper>
                            <SideMenuContainer />
                        </StyledSideMenuWrapper>
                    )}
                    <StyledMain isFullMain={isFullMain}>{children}</StyledMain>
                </StyledContainer>
                <Footer />
            </StyledPageWrapper>
            <ModalRoot />
        </>
    );
};

export default Layout;
